import Repository from "@/api/repository";
const resource = "/devices/v1/details";
export default {
    getDeviceDetails(deviceId) {
        return Repository.get(`${resource}?id=${deviceId}`);
    }
};
